import React, { useState, useEffect } from 'react';

const SystemMessage = ({ isLaunched, setIsLaunched }) => {
    const [visibleCount, setVisibleCount] = useState(0);
    const [dots, setDots] = useState('');
    const [dotStep, setDotStep] = useState(0);

    // Control the staggered appearance
    useEffect(() => {
        if (visibleCount === 0) {
            const timer = setTimeout(() => setVisibleCount(1), 0);
            return () => clearTimeout(timer);
        }

        if (visibleCount === 1) {
            const timer = setTimeout(() => setVisibleCount(2), 100);
            return () => clearTimeout(timer);
        }

        if (visibleCount === 3) {
            const timer = setTimeout(() => setVisibleCount(4), 100);
            return () => clearTimeout(timer);
        }
    }, [visibleCount]);

    // Ellipsis animation: 8 steps ("" to "..." x2), then freeze on "..."
    useEffect(() => {
        if (visibleCount !== 2) return;

        setDots('');
        setDotStep(0);

        const interval = setInterval(() => {
            setDotStep(prev => {
                const nextStep = prev + 1;

                if (nextStep >= 12) {
                    clearInterval(interval);
                    setDots('...');
                    setTimeout(() => setVisibleCount(3), 1000); // small pause before next content
                } else {
                    const dotStates = ['', '.', '..', '...', '', '.', '..', '...', '', '.', '..', '...'];
                    setDots(dotStates[nextStep]);
                }

                return nextStep;
            });
        }, 200);

        return () => clearInterval(interval);
    }, [visibleCount]);

    return (
        <div className='SystemMessage'>
            <div className='SystemMessageTitleBar'>
                <span>System Message</span>
                <img src='/images/SystemMessageCloseButton.png' alt='Close' />
            </div>
            <div className='SystemMessageContent'>
                {visibleCount >= 1 && <h1>Welcome to WAAS</h1>}
                {visibleCount >= 2 && <p>Initializing interface{dots}</p>}
                {visibleCount >= 3 && <p>Your design OS is now online. ✓</p>}
                {visibleCount >= 4 && <button onClick={() => setIsLaunched(true)}>LAUNCH</button>}
            </div>
        </div>
    );
};

export default SystemMessage;
